type User = {
  id: number
  first_name: string
  last_name: string
  email: string
}

export const parseMentionSegments = (opts: {
  text: string
  users: User[]
  onMention: (
    segment: string,
    userId: number,
    user: User | undefined,
    index: number,
  ) => any
  fallback: (segment: string, index: number) => any
}): any[] => {
  const { text, users, onMention, fallback } = opts

  const segments = text.split(/(<U-\d+>)/g)

  return segments.map((segment, index) => {
    const mentionMatch = segment.match(/<U-(\d+)>/)

    if (mentionMatch) {
      const userId = parseInt(mentionMatch[1], 10)
      const user = users.find((u) => u.id === userId)
      return onMention(segment, userId, user, index)
    }

    return fallback(segment, index)
  })
}

/**
 * Converts HTML mention tags (<U-123>) into user display names (@John Smith) for rendering in notifications.
 */
export const parseMentionsInHtml = (html: string, users: User[]): string => {
  const tempDiv = document.createElement("div")
  tempDiv.innerHTML = html

  const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null)

  const textNodes: Text[] = []
  let node: Text | null
  while ((node = walker.nextNode() as Text)) {
    textNodes.push(node)
  }

  textNodes.forEach((textNode) => {
    const text = textNode.textContent || ""
    const segments = parseMentionSegments({
      text,
      users,
      onMention: (_, __, user) => {
        const span = document.createElement("span")
        span.textContent = user
          ? `@${user.first_name} ${user.last_name}`
          : "@Deleted user"
        return span
      },
      fallback: (segment) => segment,
    })

    if (segments.length > 1) {
      const fragment = document.createDocumentFragment()
      segments.forEach((segment) => {
        if (segment instanceof HTMLElement) {
          fragment.appendChild(segment)
        } else {
          fragment.appendChild(document.createTextNode(segment))
        }
      })
      textNode.parentNode?.replaceChild(fragment, textNode)
    }
  })

  return tempDiv.innerHTML
}
